import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack, TextField, Toggle} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddTaskComment(props) {
    const [user] = useContext(AuthContext);
    const [comment, setComment] = useState('');
    const [internal, setInternal] = useState(false);

    const _submit = (e) => {
        e.preventDefault();
        const data = {comment: comment, internal: internal};
        fetch(`/api/task/${props.add}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err)
            })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddTaskComment'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setComment('');
    }, [props.add])

    var optionalProps = {};
    if (internal) optionalProps.defaultChecked = true;

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText={props.title}
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddTaskComment'>
                <TextField required multiline autoFocus label='Komentarz' value={comment}
                           onChange={(e) => setComment(e.target.value || '')}/>
                <Toggle label="Wewnętrzny" {...optionalProps} onText="Tak" offText="Nie" onChange={(e, checked) => setInternal(checked)} />
            </form>
        </Panel>
    )
}

export default AddTaskComment;


AddTaskComment.defaultProps = {
    title: 'Dodaj Komentarz',
}